export enum AppEnvironment {
  LOCAL = 'local',
  DEVELOPMENT = 'develop',
  STAGING = 'staging',
  PRODUCTION = 'production'
}
